export enum AuditEntryCategory {
  AccountCreated = 'account.created',
  AccountUpdated = 'account.updated',
  //
  AgentCreated = 'agent.created',
  AgentDeleted = 'agent.deleted',
  AgentUpdated = 'agent.updated',
  AgentStatusUpdated = 'agent.status.updated',
  AgentSkillUpdated = 'agent.skills.updated',
  AgentSkillDeleted = 'agent.skills.deleted',
  AgentSkillCreated = 'agent.skills.created',
  AgentSubAgentsAdded = 'agent.sub-agents.added',
  AgentSubAgentsRemoved = 'agent.sub-agents.removed',
  //
  ChatContextCreated = 'chat-context.created',
  ChatContextUpdated = 'chat-context.updated',
  ChatContextStatusUpdated = 'chat-context.status.updated',
  ChatContextDeleted = 'chat-context.deleted',

  ChatContextApplicationAdded = 'chat-context.application.added',
  ChatContextApplicationRemoved = 'chat-context.application.removed',
  //
  ConnectedAppCreated = 'connected-app.created',
  ConnectedAppUpdated = 'connected-app.updated',
  ConnectedAppDeleted = 'connected-app.deleted',
  //
  DataConnectionCreated = 'data-connection.created',
  DataConnectionUpdated = 'data-connection.updated',
  DataConnectionDeleted = 'data-connection.deleted',
  DataConnectionTested = 'data-connection.tested',
  //
  UserCreated = 'user.created',
  UserPasswordReset = 'user.password.reset',
  UserPermissionsUpdated = 'user.permissions.updated',
  UserUpdated = 'user.updated',
  UserLogin = 'user.login',
  IdentityProviderCreated = 'identity-provider.created',
  IdentityProviderUpdated = 'identity-provider.updated',
  IdentityProviderDeleted = 'identity-provider.deleted',
  AuthAppIdentityProviderCreated = 'auth-app.identity-provider.created',
  AuthAppIdentityProviderUpdated = 'auth-app.identity-provider.updated',
  AuthAppIdentityProviderDeleted = 'auth-app.identity-provider.deleted',
  AuthAppLogoRemoved = 'auth-app.logo.removed',
  AuthAppLogoUpdated = 'auth-app.logo.updated',
  AuthAppPrimaryColorUpdated = 'auth-app.primary-color.updated',
  AuthAppCreated = 'auth-app.created',
  AuthAppUpdated = 'auth-app.updated',
  GroupFeature = 'group.feature',
  BrandFeature = 'brand.feature',
  ApplicationFeature = 'application.feature',
  BrandQuestionCreated = 'brand.question.created',
  BrandQuestionUpdated = 'brand.question.updated',
  BrandQuestionDeleted = 'brand.question.deleted',
  BrandApplicationsUpdated = 'brand.applications.updated',
  BrandUsersUpdated = 'brand.users.updated',
  BrandUsersAdded = 'brand.users.added',
  BrandUsersRemoved = 'brand.users.removed',
  UserBrandsRemoved = 'user.brands.removed',
  UserBrandAdded = 'user.brand.added',
  //
  ApplicationCreated = 'application.created',
  ApplicationUpdated = 'application.updated',
  ApplicationStatusUpdated = 'application.status.updated',
  ApplicationChatContextAdded = 'application.chat-contexts.added',
  ApplicationChatContextRemoved = 'application.chat-contexts.removed',
  //
  ManagedSecretDeleted = 'managed-secret.deleted',
  ManagedSecretCreated = 'managed-secret.created',
  //
  ToolCreated = 'tool.created',
  UnmetNeedsDeleted = 'unmet-needs.deleted',

  CrmConnectionCreated = 'crm-connection.created',
  CrmConnectionUpdated = 'crm-connection.updated',
  CrmConnectionDeleted = 'crm-connection.deleted',
  CrmConnectionTested = 'crm-connection.tested',

  FormSchemaCreated = 'form-schema.created',
  FormSchemaUpdated = 'form-schema.updated',
  FormSchemaDeleted = 'form-schema.deleted',

  FormWorkflowCreated = 'form-workflow.created',
  FormWorkflowUpdated = 'form-workflow.updated',
  FormWorkflowDeleted = 'form-workflow.deleted',
  //
  PromptCreated = 'prompt.created',
  PromptVersionCreated = 'prompt.version.created',
  PromptDeleted = 'prompt.deleted',
}